import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { NumberFormatValues, NumericFormat } from 'react-number-format';
import { hooks as commonHooks } from '@sitebuilder/common';

export interface IncDecNumberInputProps {
    defaultValue?: number;
    onChange: (num: number) => void;
}

const IncDecNumberInput = (props: IncDecNumberInputProps) => {
    const i18n = commonHooks.useLocalization();
    const { defaultValue, onChange } = props;
    const [number, setNumber] = useState<number>(defaultValue || 0);

    const handleNumberChange = (values: NumberFormatValues) => {
        if (values.floatValue) {
            setNumber(values.floatValue);
            onChange(values.floatValue);
        }
    };

    const handleOnIncDec = (op: string) => {
        let num = number;

        if (op === 'increment') num = parseFloat((num + 1).toFixed(2));
        else num = parseFloat((num - 1).toFixed(2));

        setNumber(num);
        onChange(num);
    };

    return (
        <div className="inc-dec-number-input">
            <div className="inc-dec-number-input-group">
                <NumericFormat
                    /* @ts-ignore */
                    id="inc-dec-number-input"
                    className="number-input"
                    defaultValue={defaultValue}
                    value={number.toString()}
                    decimalSeparator="."
                    type="text"
                    thousandSeparator={false}
                    allowNegative={false}
                    onValueChange={handleNumberChange}
                />
                <div className="icon-group">
                    <FontAwesomeIcon
                        id={'increment-icon'}
                        className={'icon'}
                        icon={faChevronUp}
                        onClick={() => handleOnIncDec('increment')}
                        title={i18n.t('customSchemaWidgets_increment')}
                    />
                    <FontAwesomeIcon
                        id={'decrement-icon'}
                        className={'icon'}
                        icon={faChevronDown}
                        onClick={() => handleOnIncDec('decrement')}
                        title={i18n.t('customSchemaWidgets_decrement')}
                    />
                </div>
            </div>
        </div>
    );
};

export default IncDecNumberInput;
